
const QuantityInput = ({ value, onChange, error, isValid, maxQuantity }) => (
  <div className="mb-3">
    <label htmlFor="quantity" className="form-label fw-semibold">
      Quantité <span className="text-danger">*</span>
    </label>
    <input
      type="number"
      className={`form-control ${error ? "is-invalid" : ""} ${isValid && value ? "is-valid" : ""}`}
      id="quantity"
      placeholder={`Quantité entre 1 et ${maxQuantity}`}
      value={value}
      onChange={onChange}
      min="1"
      max={maxQuantity}
      step="1"
      required
    />
    {error && <div className="invalid-feedback d-block">{error}</div>}
    <div className="form-text">
      Quantité maximale disponible: {maxQuantity.toLocaleString()}
    </div>
  </div>
);

export default QuantityInput;